export default {"src":"/_next/static/media/calendar-icon.728d1932.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};